
























































































































































































































import {
  SfBadge,
  SfButton,
  SfCollectedProduct,
  SfImage,
  SfLink,
  SfNotification,
  SfPrice,
  SfProperty,
  SfQuantitySelector,
  SfSidebar,
  SkeletonLoader,
  CartProduct,
  SfBar
} from '~/components';

import {
  defineComponent,
  ref,
  computed,
  useRouter,
  useContext,
} from '@nuxtjs/composition-api';

import {
  useCart,
  useCartView,
  useUiNotification,
  useUiState,
  useUser,
  useWishlist,
} from '~/composables';

import CouponCode from '~/components/CouponCode.vue';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { ensureTrailingSlash } from '~/helpers/ensureTrailingSlash';

export default defineComponent({
  name: 'CartSidebarUS',
  components: {
    SkeletonLoader,
    SfNotification,
    SfSidebar,
    SfButton,
    SfLink,
    SfProperty,
    SfPrice,
    SfCollectedProduct,
    SfQuantitySelector,
    SfBadge,
    CouponCode,
    SfImage,
    CartProduct,
    SfBar,
    MainNavigation: () => import('~/components/togas/MainNavigation.vue'),
    NewProducts: () => import('~/modules/catalog/product/components/NewProducts.vue'),
  },
  setup() {
    const { app } = useContext();
    const { cart, loading: cartLoading } = useCart();
    const { isCartSidebarOpen, toggleCartSidebar, toggleLoginModal } = useUiState();
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const { send: sendNotification } = useUiNotification();
    const { isAuthenticated } = useUser();
    const clickedProductSku = ref('');
    const cartView = useCartView();
    const router = useRouter();

    const cartAddOrRemoveItemToWishlist = async (product) => {
      if (isAuthenticated.value) {
        try {
          await addOrRemoveItem(product);
          if (isInWishlist(product)) {
            sendNotification({
              id: Symbol('wishlist_added'),
              message: app.i18n.t('Item added to Wishlist') as string,
              type: 'success',
              icon: 'check',
              persist: false,
            });
          } else {
            sendNotification({
              id: Symbol('wishlist_removed'),
              message: app.i18n.t('Item removed from Wishlist') as string,
              type: 'success',
              icon: 'check',
              persist: false,
            });
          }
        } catch (e) {
          console.warn('Error: ', e);
          sendNotification({
            id: Symbol('wishlist_error'),
            message: app.i18n.t('Something went wrong') as string,
            type: 'danger',
            icon: 'check',
            persist: false,
          });
        }
      } else {
        sendNotification({
          id: Symbol('need_to_login'),
          message: app.i18n.t('Need to login message') as string,
          type: 'danger',
          icon: 'check',
          persist: false,
        });
      }
    };

    const goToCart = async () => {
      await router.push(ensureTrailingSlash(app.localePath('/cart')));
    };

    const handleViewMyAccount = async () => {
      toggleCartSidebar();
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: 'customer-my-wishlist' }));
      } else {
        await toggleLoginModal();
      }
    };

    const giftWrap = computed(() => cartGetters.getGiftWrap(cart.value));
    const merchandiseTotal = computed(() => cartGetters.getCartMerchandiseTotal(cart.value));

    const carouselSettings = ref({
      loop: true,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        744: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        480: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
        },
        0: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
        },
      },
    });

    return {
      ...cartView,
      isCartSidebarOpen,
      toggleCartSidebar,
      goToCart,
      isInWishlist,
      cartAddOrRemoveItemToWishlist,
      clickedProductSku,
      giftWrap,
      merchandiseTotal,
      cartLoading,
      carouselSettings,
      handleViewMyAccount
    };
  },
});
